import axios from '../helpers/axiosConfig';
import React, { useEffect, useState } from 'react';

import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';


 //const API_BASE = process.env.REACT_APP_API_BASE || "/api"; // ou "http://localhost:3001" selon config

const formatNumber = (n) => (typeof n === "number" ? n.toLocaleString() : n);


function Recaptotalbrca() {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [mois, setMois] = useState("");
  const [annee, setAnnee] = useState("");

  useEffect(() => {
    let mounted = true;

    const fetchStats = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await axios.get(`/personnel/stats/personnels-par-bataillon`);
        if (!mounted) return;
        // Normaliser: si la réponse est un objet unique, forcer en tableau
        //const payload = Array.isArray(res.data) ? res.data : [res.data];
        const payload = res.data?.stats ?? [];
        const totalGeneral = res.data?.totalGeneral ?? 0;
        setStats({ 
          data: payload, 
          totalGeneral,
          totalPDL: res.data.totalPDL,
          nombreFonctionnaireMilitaire: res.data.nombreFonctionnaireMilitaire        
        });
        console.log(stats);
        //setStats(payload);
      } catch (err) {
        console.error("Erreur fetch stats:", err);
        setError(err?.response?.data?.error || err.message || "Erreur réseau");
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchStats();
    return () => {
      mounted = false;
    };
  }, []);

  const handleSave = async () => {
    if (!mois || !annee) {
      toast.error("Veuillez sélectionner le mois et l'année.");
      return;
    }

    try {
      const body = {
        mois,
        annee,
        stats: stats.data,
        totalGeneral: stats.totalGeneral,
        totalPDL: stats.totalPDL,
        nombreFonctionnaireMilitaire: stats.nombreFonctionnaireMilitaire,
      };

      const res = await axios.post("/personnel/stats/sauvegarder/xc2/data", body);

      toast.success("Situation enregistrée avec succès !");
    } catch (error) {
      if (error.response?.status === 409) {
        toast.warning(error.response.data.error);
      } else {
        toast.error("Erreur de sauvegarde !");
      }
    }
  };

  const handleConsultation = async () => {
    if (!mois || !annee) {
      toast.error("Veuillez sélectionner le mois et l'année.");
      return;
    }
  
    try {
      const res = await axios.get(`/personnel/stats/consulter?mois=${mois}&annee=${annee}`);
  
      setStats({
        data: res.data.stats,
        totalGeneral: res.data.totalGeneral,
        totalPDL: res.data.totalPDL,
        nombreFonctionnaireMilitaire: res.data.nombreFonctionnaireMilitaire
      });
  
      toast.success("Situation chargée !");
    } catch (err) {
      toast.error(err?.response?.data?.error || "Erreur de chargement");
    }
  };

  

  if (loading) {
    return (
      <div className="stats-container">
        <p>Chargement des statistiques...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="stats-container">
        <p style={{ color: "red" }}>Erreur : {error}</p>
      </div>
    );
  }

  if (!stats || stats.length === 0) {
    return (
      <div className="stats-container">
        <p>Aucune statistique disponible.</p>
      </div>
    );
  }

  return (
    <div className="container">
      <div className='text-center alert alert-warning'> 
      <h2>Statistiques des personnels par bataillon</h2>
      </div>

      <div className="table-wrapper">
        <table className=" table table-bordered stats-table">
          <thead>
            <tr>
              <th style={{ width: "180px" }}>BRCA</th>
              <th style={{ width: "60px" }}>N°</th>
              <th style={{ width: "360px" }}>BATAILLON</th>
              <th style={{ width: "140px" }}>TOTAL NB</th>
            </tr>
          </thead>

          <tbody>
            {stats.data.map((user, uIndex) => {
              const battalions = user.bataillons || [];
              const rowsForUser = battalions.length > 0 ? battalions.length + 1 : 1; // +1 pour la ligne TOTAL user

              // keyUser: si userId absent, fallback sur userName+index
              const keyUser = user.userId ?? `${user.username}-${uIndex}`;

              return (
                <React.Fragment key={keyUser}>                  
                  {battalions.length === 0 ? (
                    // Cas : user sans bataillon (ligne unique)
                    <tr>
                      <td className="user-cell">{user.username}</td>
                      <td></td>
                      <td>Aucun bataillon</td>
                      <td>{formatNumber(user.totalUser ?? 0)}</td>
                    </tr>
                  ) : (
                    battalions.map((b, bIndex) => {
                      const battKey = b.bataillonId ?? `${b.bataillonName}-${bIndex}`;
                      return (
                        <tr key={battKey}>
                          {/* User fusionné verticalement : affiché seulement sur la 1ère ligne */}
                          {bIndex === 0 && (
                            <td className="user-cell" rowSpan={rowsForUser}>
                              <strong>{user.username}</strong>
                            </td>
                          )}

                           
                          <td className="number-cell">{bIndex + 1}</td>

                        
                          <td className="battalion-cell">{b.bataillonName}</td>
 
                          <td className="total-cell">{formatNumber(b.totalPersonnel ?? b.total ?? 0)}</td>
                        </tr>
                      );
                    })
                  )}

                  {/* Ligne TOTAL pour l'utilisateur */}
                  <tr className="user-total-row">
                    {/* On laisse la première two columns empty because user cell occupies first column */}
                    <td colSpan={2} className="total-label text-right ">
                      TOTAL {user.username}
                    </td>
                    <td className="user-total-number">{formatNumber(user.totalUser ?? battalions.reduce((s, x) => s + (x.totalPersonnel ?? x.total ?? 0), 0))}</td>
                  </tr>
                </React.Fragment>
              );
            })}
            <tr className="total-general-row bg-warning">
              <td colSpan={3} className="text-right"><strong>TOTAL GENERAL</strong></td>
              <td><strong style={{ fontSize: "34px" }} >{formatNumber(stats.totalGeneral)}</strong></td>
            </tr>
            <tr className="bg-info">
              <td colSpan={3} className="text-right">
                <strong>TOTAL PDL</strong>
              </td>
              <td><strong style={{ fontSize: "34px" }} >{formatNumber(stats.totalPDL)}</strong></td>
            </tr>

            <tr className="  ">
              <td colSpan={3} className="text-right">
                <strong>FONCTIONNAIRES MILITAIRES</strong>
              </td>
              <td><strong style={{ fontSize: "34px" }} >{formatNumber(stats.nombreFonctionnaireMilitaire)}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* 🔽 Formulaire mois + année + bouton sauvegarde */}
      <div className="card p-3 mb-3">

        <div className="row">

          <div className="col-md-3">
            <label>Mois :</label>
            <select className="form-control" value={mois} onChange={(e) => setMois(e.target.value)}>
              <option value="">Sélectionner...</option>
              {[...Array(12)].map((_, i) => (
                <option key={i + 1} value={i + 1}>{i + 1}</option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>Année :</label>
            <select className="form-control" value={annee} onChange={(e) => setAnnee(e.target.value)}>
              <option value="">Sélectionner...</option>
              {Array.from({ length: 20 }, (_, i) => 2020 + i).map((year) => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>

          <div className="col-md-3 d-flex align-items-end">
            <button className="btn btn-success w-100" onClick={handleSave}>
              💾 Sauvegarder la situation
            </button>
          </div>

          <div className="col-md-3 d-flex align-items-end">
            <button className="btn btn-danger w-100" onClick={handleConsultation} >
              Consultation SME
            </button>
          </div>
         {/*  on va recupérer la liste des date dans la table StatsDate et on va les mettre ici en bas du bouton Consultation SME
          de forme liste en utilisant bootstrap, et lorsque on clic sur la date exemple "SEPTEMBRE 2025" le programe va trouver les données dans la table StatsDate et StatsEffectifs 
          et les afficher sur ce front meme
          on fixe la largeur du div par exemple 5cm (à toi de voir) et on va utiliser scroll pour scoller la liste des date en bas, 
          je sais pas si on va utilisé les variables ${mois} ${annee} pour faire la requette ou id ? */}

        </div>

      </div>

 
    </div>
  );
}

export default Recaptotalbrca;